// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model__container{bottom:0;left:0;position:absolute;right:0;top:0}`, "",{"version":3,"sources":["webpack://./src/components/Model/styles.css"],"names":[],"mappings":"AAAA,kBAIE,QAAS,CACT,MAAO,CAJP,iBAAkB,CAElB,OAAQ,CADR,KAIF","sourcesContent":[".model__container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
